import { chakra, Flex } from '@chakra-ui/react';

import {
    CellDimensions,
    DynamicGridFiltersBottomHeight,
    DynamicGridFiltersTopHeight
} from '@containers/activity-router/data-grid-container/data-grid-container.styled';

export const student = {
    h: DynamicGridFiltersBottomHeight,
    transform: 'skewX(-46deg) translate(60px, 0px)',
    w: DynamicGridFiltersTopHeight
};

export const details = chakra(Flex, {
    label: 'loading-students-details',
    baseStyle: {
        w: CellDimensions.w,
        h: '41px',
        alignItems: 'center',
        justifyContent: 'center',
        borderRight: '1px solid',
        borderColor: 'neutral.100',
        m: '8px 0',
        _first: {
            borderLeft: '1px solid',
            borderColor: 'neutral.100'
        }
    }
});

export const assigned = {
    borderRadius: '8px',
    h: '36px',
    w: '57px'
};
